import type { Block } from '../../../data/referenceGuides/types';
import { assertNever } from '../../../data/referenceGuides/types';
import { CalloutBlock } from './CalloutBlock';
import { CompareBlock } from './CompareBlock';
import { LifecycleBlock } from './LifecycleBlock';
import { MatrixBlock } from './MatrixBlock';
import { PillarsBlock } from './PillarsBlock';
import { ProseBlock } from './ProseBlock';
import { ThrulineFitBlock } from './ThrulineFitBlock';
interface BlockRendererProps {
  block: Block;
  /** Section heading, reused as the accessible caption for tables. */
  sectionHeading: string;
  onSolutionClick?: (to: string) => void;
}

/**
 * The single switch that turns typed content into UI.
 *
 * The `assertNever` default is load-bearing: adding a Block kind to the union
 * without adding a case here is a COMPILE error, not a runtime surprise. That
 * is what makes the extension policy in types.ts enforceable rather than
 * aspirational.
 */
export function BlockRenderer({
  block,
  sectionHeading,
  onSolutionClick
}: BlockRendererProps) {
  switch (block.kind) {
    case 'pillars':
      return <PillarsBlock columns={block.columns} items={block.items} data-id="element-270" data-mp="13qf0zspzcges" />;
    case 'lifecycle':
      return <LifecycleBlock stages={block.stages} data-id="element-271" data-mp="1if1i9zz63i8n" />;
    case 'compare':
      return <CompareBlock cards={block.cards} columns={block.columns} rows={block.rows} caption={sectionHeading} data-id="element-272" data-mp="1dfgffegvmpqn" />;
    case 'matrix':
      return <MatrixBlock columns={block.columns} rows={block.rows} legendNote={block.legendNote} caption={sectionHeading} data-id="element-273" data-mp="pqx7j01qoez3" />;
    case 'callout':
      return <CalloutBlock variant={block.variant} title={block.title} body={block.body} data-id="element-274" data-mp="ksvryp3iuxsd" />;
    case 'prose':
      return <ProseBlock paragraphs={block.paragraphs} data-id="element-275" data-mp="yo7lwu9usk88" />;
    case 'thrulineFit':
      return <ThrulineFitBlock intro={block.intro} scenarios={block.scenarios} solutions={block.solutions} onSolutionClick={onSolutionClick} data-id="element-276" data-mp="ur1qcwq4dlsh" />;
    default:
      return assertNever(block, 'BlockRenderer');
  }
}